import React, { Fragment, memo } from 'react';

import { AsyncBetslipFreebet } from 'modules/freebet/async';
import BetslipStakeInput from '../../BetslipStakeInput';
import Error from '../../Error';
import PlaceBet from '../../PlaceBet';
import BetDetails, { TotalType } from '../BetDetails';
import useExpressPart from './useExpressPart';

import './expressPartMob.scss';

interface Props {
    betslipBetId: string;
}

const ExpressPartMob: React.FC<Props> = ({ betslipBetId }) => {
    const props = useExpressPart({ betslipBetId });

    if (!props) return null;

    const {
        changeStakeHandler,
        maxStake,
        formattedTotalOdd,
        totals: { totalStake, totalWin },
        isFreebetSelected,
        errorMsgs,
        toggleFreeBetHandler,
        betslipOddIds,
        betType,
        isSuspended,
        stake,
    } = props;

    return (
        <Fragment>
            <div
                styleName="over-footer"
                className="__app-ExpressPartMob-over-footer"
            >
                {errorMsgs.length > 0 && (
                    <div styleName="errors">
                        <Error messages={errorMsgs} />
                    </div>
                )}
            </div>
            <AsyncBetslipFreebet
                toggleFreebetCallback={toggleFreeBetHandler}
                betslipOddIds={betslipOddIds}
                betType={betType}
                isFreebetInProcess={isSuspended}
            />
            <div
                styleName="container"
                className="__app-ExpressPartMob-container"
            >
                {!isFreebetSelected && (
                    <BetslipStakeInput
                        maxStake={maxStake}
                        changeValue={changeStakeHandler}
                        value={stake}
                        isDisabled={isFreebetSelected}
                    />
                )}

                <BetDetails
                    total={formattedTotalOdd}
                    totalType={TotalType.odd}
                    totalWin={totalWin}
                />
                <PlaceBet
                    betslipBetId={betslipBetId}
                    totalStake={totalStake}
                    isFreebetActive={isFreebetSelected}
                />
            </div>
        </Fragment>
    );
};

export default memo(ExpressPartMob);
